import React, {CSSProperties} from 'react';

import './../img.scss'

interface IImgLayoutProps {
    src: string
    style?: CSSProperties
    className?: string
    width?: string
    height?: string
    alt?: string
    onClick?: ()=>void
}

const ImgLayout: React.FC<IImgLayoutProps> = (props) => {
    return (
        <div onClick={props.onClick} className={`img-component`}>
            <img className={`${props.className !== undefined ? props.className : ''}`} style={props.style} width={props.width} height={props.height} src={props.src} alt={props.alt ? props.alt : props.src}/>
            <div className='url-img-copy'>__img__{props.src}__img__</div>
        </div>
    );
};

export default ImgLayout;